import { render, staticRenderFns } from "./DeliveryPickupMenu.vue?vue&type=template&id=5997ae6e&scoped=true&"
import script from "./DeliveryPickupMenu.vue?vue&type=script&lang=js&"
export * from "./DeliveryPickupMenu.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPickupMenu.vue?vue&type=style&index=0&id=5997ae6e&scoped=true&lang=css&"
import style1 from "./DeliveryPickupMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997ae6e",
  null
  
)

export default component.exports